/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './flow';
import './model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "WorkflowRequest": {
                    "fields": {
                      "flow": {
                        "type": ".squareup.bbfrontend.service.v1.Flow",
                        "id": 1,
                        "rule": "optional"
                      },
                      "screens": {
                        "type": ".squareup.bbfrontend.service.v1.ScreenContainer",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "WorkflowResponse": {
                    "fields": {
                      "flow": {
                        "type": ".squareup.bbfrontend.service.v1.Flow",
                        "id": 1,
                        "rule": "optional"
                      },
                      "screens": {
                        "type": ".squareup.bbfrontend.service.v1.ScreenContainer",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "BalancesWorkflowServiceV1": {
                    "methods": {
                      "GetWorkflow": {
                        "requestType": ".squareup.bbfrontend.service.v1.WorkflowRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.WorkflowResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.WorkflowRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.WorkflowResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BalancesWorkflowServiceV1) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE WorkflowRequest @ squareup/bbfrontend/v1/service.proto at 15:1
 */
export const WorkflowRequest = $root.lookupType('squareup.bbfrontend.service.v1.WorkflowRequest');
fixType(WorkflowRequest, {
  flow: {
    required: true
  }
});
Builder.createAndAttachToType(WorkflowRequest);
/**
 * SOURCE WorkflowResponse @ squareup/bbfrontend/v1/service.proto at 28:1
 */
export const WorkflowResponse = $root.lookupType('squareup.bbfrontend.service.v1.WorkflowResponse');
fixType(WorkflowResponse, {
  flow: {
    required: true
  }
});
Builder.createAndAttachToType(WorkflowResponse);
/**
 * SOURCE BalancesWorkflowServiceV1 @ squareup/bbfrontend/v1/service.proto at 37:1
 */
export const BalancesWorkflowServiceV1 = $root.lookupService('squareup.bbfrontend.service.v1.BalancesWorkflowServiceV1');